import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`In this template, We have used some custom helper functions which is located in`}</p>
    <blockquote>
      <p parentName="blockquote">{`[your-frontend-project]`}{` = admin `}{`[`}<inlineCode parentName="p">{`rest`}</inlineCode>{`]`}{` or shop`}</p>
    </blockquote>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`cd [your-frontend-project]/src/utils/
`}</code></pre>
    <p>{`You can use or customize these helper fuctions according to your needs.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      